// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var Coveo = require("coveo-search-ui");
var SearchEndpointHelper = (function () {
    function SearchEndpointHelper() {
    }
    SearchEndpointHelper.initializeEndpoint = function (options) {
        Coveo.SearchEndpoint.endpoints["default"] = new Coveo.SearchEndpoint({
            restUri: options.restEndpointUri,
            queryStringArguments: { 'sitecoreItemUri': options.sitecoreItemUri, 'siteName': options.siteName }
        });
    };
    return SearchEndpointHelper;
}());
exports.__esModule = true;
exports["default"] = SearchEndpointHelper;



//////////////////
// WEBPACK FOOTER
// ./Base/SearchEndpointHelper.ts
// module id = 12
// module chunks = 0